'use strict';

export const LayoutConstants = Object.freeze({
  MAX_CPI_THRESHOLD: 10,
  DEFAULT_FLEXIBILITY: 100,
  DEFAULT_SUPPLIER_ALLOCATION: 100,
  CONFIRM_MODAL: {
    EDIT_SUPPLIER: {
      TEXT: 'The total completes among suppliers adds up to more than 100% of the survey’s goal. Do you want to proceed?',
      CONFIRM_BUTTON_TEXT: 'Yes',
      CANCEL_BUTTON_TEXT: 'No',
    },
    TEMPLATES: {
      TEXT: 'Do you want to override the current template?',
      CONFIRM_BUTTON_TEXT: 'Confirm',
      CANCEL_BUTTON_TEXT: 'No',
    },
  },
  TEMPLATE_MODAL: {
    FOLDER_DROPDOWN: {
      MAX_NAVIGATION_DEPTH: 1,
    },
  },
  PRICING_TYPE: {
    SUPPLIER_RATES: 'Supplier Rates',
    PRICE_OVERRIDE: 'Price Override',
    SELECTIVE_MANUAL_OVERRIDE: 'Selective Manual Override',
  },
});
